import React, { useLayoutEffect } from 'react'
import { NavBar } from './nav/NavBar'
import { Outlet, useLocation } from 'react-router-dom'
import { Footer } from '../components/Footer'
import { SystemMessage } from '../components/SystemMessage'
import { useDispatch, useSelector } from "react-redux"
import { setNotification, selectNotification } from "../redux/notificationSlice"
import { setModal } from "../redux/modalSlice"

export default function Layout() {
  const location = useLocation();
  const dispatch = useDispatch()
  const notification = useSelector(selectNotification)
  // Only the type: Layout wraps the Outlet, so subscribing to the whole modal
  // object would re-render every page on any setModal dispatch.
  const modalType = useSelector((state) => state.modal.type)

  // Layout effect, not passive: clearing after paint lets the previous record's
  // history drawer render open over the new one before it slides shut.
  useLayoutEffect(() => {
    if (notification.type) {
      dispatch(setNotification({ type: '', body: '' }))
    }
    // The history drawer points at a single record's audit endpoint, so it must not
    // survive navigation to a different record.
    if (modalType === 'history') {
      dispatch(setModal({ is_active: false, type: '', title: '', content: '', options: {}, parent_modal: '' }))
    }
  }, [location.key]);

  return (
    <>
      <SystemMessage />
      <NavBar />
      <Outlet />
      <Footer />
    </>
  )
}
